import { cn } from "@/lib/utils/cn";

type SpinnerProps = { className?: string; size?: "sm" | "md" | "lg"; label?: string };
const sizes = { sm: "size-4 border-2", md: "size-6 border-2", lg: "size-10 border-[3px]" };

export function Spinner({ className, size = "md", label = "Loading" }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn("inline-block animate-spin rounded-full border-current border-t-transparent", sizes[size], className)}
    />
  );
}
